module.exports = __webpack_public_path__ + "static/filters_identification-718ac64eda0a9118fa1b69bb15f93e25.png";